import { Component } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { Store, StoresService } from 'src/app/core/stores.service';
import { ERROR_STORE_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-home-stores',
  templateUrl: './home-stores.component.html',
  styleUrls: ['./home-stores.component.scss'],
})
export class HomeStoresComponent {
  is_list_running: boolean = false;
  stores?: Store[];

  constructor(
    private stores_service: StoresService,
    private error_service: ErrorService,
    private navigation_service: NavigationService,
  ) {}

  ngOnInit(): void {
    this.listStores();
  }

  onRefresh(): void {
    this.listStores();
  }

  onSeeAllClick(): void {
    this.navigation_service.toStores();
  }

  listStores(): void {
    this.is_list_running = true;
    this.stores_service.listStores({ cursor: null, limit: 5 }).subscribe({
      next: response => {
        this.stores = response.data.data;
        this.is_list_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        if (processed_error.code == ERROR_STORE_NOT_FOUND) {
          this.stores = [];
        } else {
          this.error_service.processApiError(processed_error.code, processed_error.message);
        }
        this.is_list_running = false;
      },
    });
  }
}
